document.addEventListener('DOMContentLoaded', function () {
    'use strict';

    function initializeSavedFilterModal() {
        var $modal = $('#savedFilterModal');
        if (!$modal.length) return;

        var $firstStep = $modal.find('.step.active');

        $('body').off('input.validateNotEmpty').on('input.validateNotEmpty', '.validate-notEmpty', function () {
            let $this = $(this);
            let $activeStep = $('.step.active');
            $activeStep.find('.btn-next').prop('disabled', true);
            if ($this.val() !== '' && ($this.val()).length > 2) {
                $activeStep.find('.btn-next').prop('disabled', false);
            }
        });

        $('body').off('click.btnNext').on('click.btnNext', '.step.active .btn-next', function () {
            let $this = $(this);
            let $nextStep = $(`.step--${$this.attr('data-next')}`);

            $('.step').removeClass('active');
            $nextStep.addClass('active');
        });

        $('body').off('change.changeStep').on('change.changeStep', '.change-step', function () {
            let $this = $(this);
            let value = $this.val();
            let $activeStep = $('.step.active');

            if (value === 'update') {
                $('#chooseFilterSelect').removeClass('d-none');
                $activeStep.find('.btn-next').attr('data-next', '3');
            } else {
                $('#chooseFilterSelect').addClass('d-none');
                $activeStep.find('.btn-next').attr('data-next', value);
            }
        });

        $('body').off('change.validateNotEmptyOnChange').on('change.validateNotEmptyOnChange', '.validate-notEmptyOnChange', function () {
            let $activeStep = $('.step.active');
            $activeStep.find('.btn-next').prop('disabled', false);
        });

        const modalEl = document.getElementById('savedFilterModal');
        modalEl.addEventListener('hidden.bs.modal', function (event) {
            $('.step').removeClass('active');
            $firstStep.addClass('active');
        });
    }

    initializeSavedFilterModal();
});
